///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2024
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { setCarrierView, toggleExclude } from "../slices/analyticsSlice";
import { getDivisionCurrency } from "./laneViewColumns";
import messages from "./messages";
import { cellUnit, controls } from "./types";

export const shipperViewColumns = [
  {
    header: messages.shipper.defaultMessage,
    field: "shipperName",
    cellUnit: cellUnit.none,
    unitLeft: true,
    filter: true,
    left: true,
    control: controls.none,
    isDraggable: false
  },
  {
    header: messages.vol.defaultMessage,
    field: "volume",
    cellUnit: cellUnit.none,
    unitLeft: true,
    rangeFilter: true,
    right: true,
    control: controls.none,
    isDraggable: false
  },
  {
    header: messages.carriers.defaultMessage,
    field: "carriers",
    cellUnit: cellUnit.none,
    unitLeft: true,
    rangeFilter: true,
    right: true,
    control: controls.button,
    isDraggable: false,
    buttonClick: setCarrierView
  },
  {
    header: messages.cost.defaultMessage,
    field: "cost",
    unitLeft: true,
    right: true,
    control: controls.none,
    isDraggable: false,
    formatCurrency: getDivisionCurrency
  },
  {
    header: messages.cpm.defaultMessage,
    field: "cpm",
    unitLeft: true,
    right: true,
    control: controls.none,
    isDraggable: false,
    formatCurrency: getDivisionCurrency,
    alternateHeader: messages.cpKm.defaultMessage
  },
  {
    header: messages.miles.defaultMessage,
    field: "distance",
    cellUnit: cellUnit.none,
    unitLeft: true,
    rangeFilter: true,
    right: true,
    control: controls.none,
    isDraggable: false,
    alternateHeader: messages.km.defaultMessage
  },
  {
    header: messages.gmpl.defaultMessage,
    field: "margin",
    unitLeft: true,
    right: true,
    control: controls.none,
    isDraggable: false,
    formatCurrency: getDivisionCurrency
  },
  {
    header: messages.rate.defaultMessage,
    field: "rate",
    unitLeft: true,
    right: true,
    control: controls.none,
    isDraggable: false,
    formatCurrency: getDivisionCurrency
  },
  {
    header: "",
    field: "exclude",
    cellUnit: cellUnit.none,
    unitLeft: true,
    center: true,
    control: controls.button,
    isDraggable: false,
    buttonClick: toggleExclude,
    buttonHeader: areAllLoadsExcluded =>
      areAllLoadsExcluded
        ? messages.includeAll.defaultMessage
        : messages.excludeAll.defaultMessage
  }
];

export default shipperViewColumns;
